
export const BERS = ['UNKNOWN', 'G', 'F', 'E2', 'E1', 'D2', 'D1', 'C3', 'C2', 'C1', 'B3', 'B2', 'B1', 'A3', 'A2', 'A1'];
export const CALLBACK_THRESHOLD_FTB = 150000;
export const CALLBACK_THRESHOLD_MOVER = 150000;
export const CALLBACK_THRESHOLD_SWITCHER = 150000;
export const CREATE_PARAMS = ['amount', 'ber', 'home_value', 'purpose', 'rtc', 'term'];
export const FIXED_YEARS = [1, 2, 3, 4, 5, 7, 10, 15, 20, 25, 30];
export const LIFETIME_LOANS_MIN_AGE = 60;
export const LOAN_MAX_MULTIPLIER = 0.9;
export const MORTGAGE_PURPOSES = ['first-time-buyer', 'moving-home', 'switching-mortgage'];
export const MORTGAGE_STAGES = ['applying', 'considering'];
export const MORTGAGE_STEPS = ['step-1', 'step-2', 'step-3', 'callback-1', 'callback-2', 'callback-3', 'your-results', 'thank-you'];
export const PURPOSES = ['FTB', 'BTL', 'TRD', 'SM', 'LL'];
export const RATE_TYPES = ['ALL', 'VAR', 'FIX'];
export const UPDATE_PARAMS = ['amount', 'ber', 'filtered_providers', 'home_value', 'rtc', 'sort_order', 'term'];
